import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTriangleExclamation,
  faFileLines,
} from "@fortawesome/free-solid-svg-icons";
import AlertDetailsModal from "./modals/alertdetailsmodal";

import { Backdrop, CircularProgress } from "@mui/material";
import FullScreenLabDetailsModal from "./modals/fulscreenlabmodal";
import FileViewerModal from "./modals/FileViewrModal";
import SummaryModal from "./modals/summarymodal";
import hubApi from "api/hubapi";
import { alert, share } from "./utils/svg";
import CriticalAlertsShareModal from "./modals/expandmodals/criticalalertexp";


const statusStyles = {
  HIGH: {
    badge: "bg-red-100 text-red-600",
    border: "border-l-4 border-red-500",
    text: "text-red-600",
  },
  LOW: {
    badge: "bg-yellow-100 text-yellow-600",
    border: "border-l-4 border-yellow-500",
    text: "text-yellow-600",
  },
  NORMAL: {
    badge: "bg-green-100 text-green-600",
    border: "border-l-4 border-green-500",
    text: "text-green-600",
  },
  DEFAULT: {
    badge: "bg-gray-100 text-gray-600",
    border: "border-l-4 border-gray-300",
    text: "text-gray-600",
  },
};

const CriticalAlerts = ({ patient_insights,view}) => {
  const alerts = patient_insights?.critical_alerts?.data_rows || [];
  const issuesCount = alerts.length;
  const [openSummaryModal, setOpenSummaryModal] = useState(false);
  const [summaryHtml, setSummaryHtml] = useState('');

const[imageModalOpen, setImageModalOpen] = useState(false);
const[imagedata, setImageData] = useState(null);
const [labsModal,setLabsModal] = useState(false);
const [labsData,setLabsData] = useState(null);
const [shareModalOpen, setShareModalOpen] = useState(false);

const [loadingDetails, setLoadingDetails] = useState(false);

  const [selectedAlert, setSelectedAlert] = useState(null);
const fetchdata = async (x) => {
  try {
    setLoadingDetails(true);

    const parsedArray = x.map(item => JSON.parse(item));
    const { url: fullUrl, http_method, payload } = parsedArray[0] || {};

    if (!fullUrl) {
      console.warn("URL not found in parsed data");
      return;
    }

    const urlObj = new URL(fullUrl);
    let path = urlObj.pathname;
    if (path.startsWith("/ag/")) {
      path = path.replace("/ag", "");
    }

    let response;
    if (http_method?.toLowerCase() === 'post') {
      response = await hubApi.post(path, JSON.parse(payload));
    } else {
      response = await hubApi.get(path);
    }

    console.log("API Response:", response.data);

    if (response && typeof response === 'object' && 'files' in response) {
      setImageData(response);
      setImageModalOpen(true);
    } else if (
      response &&
      typeof response === 'object' &&
      'data' in response &&
      typeof response.data === 'object' &&
      response.data !== null &&
      'dates' in response.data
    ) {
      console.log(response.data, 'labs data received');
      setLabsData(response.data || []);
      setLabsModal(true);
    } else if (
      response &&
      typeof response === 'object' &&
      'data' in response &&
      typeof response.data === 'object' &&
      response.data !== null &&
      'summaryhtml' in response.data
    ) {
      setSummaryHtml(response.data || []);
      setOpenSummaryModal(true);
    } else {
      console.warn("Unexpected response format:", response);
    }

  } catch (error) {
    console.error("Failed to parse data or call API:", error);
  } finally {
    setLoadingDetails(false);
  }
};


  return (
<div className="h-full w-full flex flex-col">

<div
  className={`bg-white text-xs text-start h-full ${view==1?"w-full":''}`}
  style={{
    borderRadius: '8.75px',
    boxShadow: '0 0 4px 0 rgba(0, 0, 0, 0.25)',
    backdropFilter: 'blur(3px)',
    WebkitBackdropFilter: 'blur(3px)',
  }}
>

        {/* Header */}
<div className="flex justify-between items-center px-3 py-2 rounded-t-md">
  {/* Left Side: Icon + Label + Issues */}
  <div className="flex items-center gap-2 text-[#2C5282] font-semibold text-lg">
    {alert}
    <span>Critical Alerts</span>
    
    {issuesCount > 0 && (
<span className="bg-[#EF4343] text-white text-[10px] leading-none px-[10px] py-[4px] rounded-full ml-2 whitespace-nowrap inline-flex items-center h-fit">
  {issuesCount} High
</span>

    )}
  </div>

  {/* Right Side: Share Icon */}
{!view==1&&<div onClick={() => setShareModalOpen(true)} className="cursor-pointer">
  {share}
</div>}

</div>


        {/* Alert List */}
    <div className={`space-y-3 overflow-y-auto ${view === 1 ? 'p-4' : 'p-3'}`}>

          {alerts.map((alert, index) => {
            const status = alert.status?.toUpperCase();
            const style = statusStyles[status] || statusStyles.DEFAULT;

            return (
             <div
  key={index}
  className={`bg-white ${view === 1 ? 'p-4' : 'p-2'} rounded ${style.border} shadow-sm cursor-pointer`}
  onClick={(e) => {
    e.stopPropagation();
    setSelectedAlert(alert);
  }}
>

               <div className={`flex justify-between items-center text-gray-800 font-medium ${view === 1 ? 'text-xs' : 'text-xs'}`}>

                  <div className="flex items-center gap-1">
                    <span>{alert.label || alert.finding}</span>
                  {Array.isArray(alert?.source_node_id) &&view==0&&
  alert.source_node_id.every(item => {
    try {
      JSON.parse(item);
      return true;
    } catch {
      return false;
    }
  }) && (
    <div
      onClick={(e) => {
        e.stopPropagation();
        fetchdata(alert.source_node_id);
      }}
      className="cursor-pointer"
    >
      <FontAwesomeIcon
        icon={faFileLines}
        className="text-gray-400 text-sm"
      />
    </div>
)}

                   
                  </div>
                  <div className="flex items-center gap-2">

    {status && (
                    <span
                      className={`text-[10px] px-1.5 py-0.5 rounded-full font-semibold uppercase ${style.badge}`}
                    >
                      {status}
                    </span>
                  )}
                         {Array.isArray(alert?.source_node_id) &&view==1&&
  alert.source_node_id.every(item => {
    try {
      JSON.parse(item);
      return true;
    } catch {
      return false;
    }
  }) && (
    <div
      onClick={(e) => {
        e.stopPropagation();
        fetchdata(alert.source_node_id);
      }}
      className="cursor-pointer"
    >
      <FontAwesomeIcon
        icon={faFileLines}
        className="text-gray-400 text-sm"
      />
    </div>
)}
                  </div>
              
                  
                </div>
                <div className={`text-[11px] ${style.text}`}>{alert.value}</div>
                {alert.clinical_significance && (
                  <div className="text-[11px] italic text-gray-500">
                    {alert.clinical_significance}
                  </div>
                )}
                 {alert.guideline_reference &&view===1&& (
          <div >📖
            <a
              href={alert.guideline_reference.link}
              target="_blank"
              rel="noopener noreferrer"
                onClick={(e) => e.stopPropagation()}
              className="text-blue-600 hover:text-blue-800 text-xs font-medium"
            >
                {alert.guideline_reference.source} →
            </a>
          </div>
        )}
              </div>
            );
          })}
        </div>
      </div>
<Backdrop
                       sx={{
                         color: 'secondary.main', // Sets the CircularProgress color to secondary
                         backgroundColor: 'rgba(255, 255, 255, 0.5)', // Semi-transparent white background
                         zIndex: (theme) => theme.zIndex.drawer + 1
                       }}
                       open={loadingDetails}
                     >
                       <CircularProgress color="secondary" />
                     </Backdrop>
  <SummaryModal
        open={openSummaryModal}
        onClose={() => {
          setOpenSummaryModal(false);
          setSummaryHtml("");
        }}
        htmlContent={
        loadingDetails? (
            `<div class="flex justify-center items-center h-40"><div class="text-center"><svg class="animate-spin h-6 w-6 text-blue-600 mx-auto" viewBox="0 0 24 24"></svg><p>Loading...</p></div></div>`
          ) : (
            summaryHtml
          )
        }
      />
{imageModalOpen && imagedata && (<FileViewerModal open={imageModalOpen} onClose={()=>{
  setImageData(null)
  setImageModalOpen(false)
}} data={imagedata}/>)}
      {labsModal && !loadingDetails && labsData && (
        <FullScreenLabDetailsModal
          open={labsModal}
          onClose={() => {
            setLabsModal(false);
            setLabsData(null);
          }}
          data={labsData}
        />
      )}
      <CriticalAlertsShareModal
  open={shareModalOpen}
  onClose={() => setShareModalOpen(false)}
  patient_insights={patient_insights}
/>

      <AlertDetailsModal
      view={view}
        isOpen={!!selectedAlert}
        onClose={() => setSelectedAlert(null)}
        alert={selectedAlert}
      />
    </div>
  );
};

export default CriticalAlerts;
